import React from 'react';
import Checkbox from './Checkbox';
import DatePicker from './DatePicker';
import Dropdown from './Dropdown';
import PHQ2Label from './PHQ2Label';
import RadioGroup from './RadioGroup';
import TextArea from './TextArea';
import TextInput from './TextInput';
import NumberInput from './NumberInput';
import RatingInput from './Rating';
import DropDownDynamicOptions from './DropDownDynamicOptions';
import PhoneNumber from './PhoneNumber';
import Zipcode from './Zipcode';
import Email from './Email';
import Table from './Table';
import DynamicDropDown from './DynamicDropDown';
const FormElements = (props) => {
    const pageHeaderWithName = (questionHeaderTemplate, nameToPlace) => {
        let questionHeader = questionHeaderTemplate ? questionHeaderTemplate.replace('[name]', props?.nameToReplace || '') : '';

        return (
            <div
                className="assessment-question-header"
                dangerouslySetInnerHTML={{
                    __html: questionHeader
                }}
            ></div>
        );
    };
    let input;

    switch (props.type) {
        case 108:
        case 118:
            input = <TextInput {...props} />;
            break;
        case 105:
        case 119:
            input = <TextArea {...props} />;
            break;
        case 106:
        case 114:
            input = <RadioGroup {...props} />;
            break;
        case 104:
            input = <Checkbox {...props} />;
            break;
        case 103:
        case 120:
            input = <Dropdown {...props} />;
            break;
        case 109:
        case 121:
            input = <DatePicker {...props} />;
            break;
        case 110:
            input = <PHQ2Label {...props} />;
            break;
        case 111:
        case 128: // This is for entering family member count
            input = <NumberInput {...props} />;
            break;
        case 112:
            input = <RatingInput {...props} />;
            break;
        case 113:
        case 126:
            input = <DropDownDynamicOptions {...props} />;
            break;
        case 115:
        case 122:
            input = <PhoneNumber {...props} />;
            break;
        case 116:
        case 123:
        case 127:
            input = <Zipcode {...props} />;
            break;
        case 117:
        case 124:
            input = <Email {...props} />;
            break;
        case 125:
            input = <DynamicDropDown {...props} />;
            break;
        case 'table':
            input = <Table {...props} />;
            break;
        default:
            input = pageHeaderWithName(props.questionHeaderTemplate);
    }

    return input;
    // }
};

export default FormElements;
